export const ALLOWED_COUNTRIES = ['ES', 'FR'];
